"use client";

import browserFastApiClient from "@/core/fastapi/client.browser";
import { getMeiliUserTokenApiStorage } from "@/generated/fastapi";

interface MeiliUserTokenSession {
  userToken: string | null;
  expiresAt: string | null;
}

export async function fetchMeiliUserToken(
  accessToken: string | null | undefined,
): Promise<MeiliUserTokenSession | null> {
  if (!accessToken) {
    return null;
  }

  try {
    const response = await getMeiliUserTokenApiStorage({
      client: browserFastApiClient,
      auth: accessToken,
    });

    if (response.status !== 200 || !response.data) {
      return null;
    }

    if (
      response.data.status !== "success" &&
      response.data.status !== "created"
    ) {
      return null;
    }

    return {
      userToken: response.data.user_token ?? null,
      expiresAt: response.data.expires_at ?? null,
    };
  } catch {
    return null;
  }
}
